/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HealthCampTransaction from './health-camp-transaction';
import HealthCampTransactionDetail from './health-camp-transaction-detail';
import HealthCampTransactionUpdate from './health-camp-transaction-update';
import HealthCampTransactionDeleteDialog from './health-camp-transaction-delete-dialog';

const HealthCampTransactionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HealthCampTransaction />} />
    <Route path="new" element={<HealthCampTransactionUpdate />} />
    <Route path=":id">
      <Route index element={<HealthCampTransactionDetail />} />
      <Route path="edit" element={<HealthCampTransactionUpdate />} />
      <Route path="delete" element={<HealthCampTransactionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HealthCampTransactionRoutes;
